// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"455":"daily_health","854":"pdfjs","936":"daily_health_policy"}[chunkId] || chunkId) + "." + {"124":"3212eb33","455":"7191467c","854":"723a2ef1","936":"6e24dd6d"}[chunkId] + ".js";
};